import { useQuery } from "@apollo/client";
import { VIEWER_QUERY } from "components/auth/query";
import { Feature, getViewer } from "types/gql-types";
import { FeatureCallback } from "./types";

export const useFeature = (name?: Feature): boolean | FeatureCallback => {
  const query = useQuery<getViewer>(VIEWER_QUERY);
  const callback: FeatureCallback = (callbackName) => {

    if (query.loading || query.error || !query.data || !query.data.viewer) {
      return false;
    }
    if (callbackName === null) return true;

    return query.data.viewer.features.some((feature) => feature.name === callbackName);
  };

  switch (typeof name) {
    case "undefined":
      return callback as FeatureCallback;
    case "string":
      return callback(name) as boolean;
    default:
      throw new Error("use feature received impossible input");
  }
};
